import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Helpers } from '../../../helpers';
import { ApiService } from '../../pages/api-service.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../auth/_services/authentication.service';

@Component({
    selector: "app-header-nav",
    templateUrl: "./header-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class HeaderNavComponent implements OnInit, AfterViewInit {

    public isAdmin: Boolean
    public FV = false;
    public navbarlist = [];

    public _username;
    constructor(public apiService: ApiService, public auth: AuthenticationService, public router: Router) { }

    ngOnInit() { this.loadusername(); }

    public loadusername() {
        Helpers.setLoading(true);
        let user = JSON.parse(localStorage.getItem('currentUser'));
        if (!!user) {
            this.apiService.me().subscribe(result => {
                let res = result
                if (res['has_changed_password'] == true) {
                    if (res['first_name']) { this._username = res['first_name'] } else { this._username = ''; }
                    let role = res['role'].modules;
                    let mrole = role.map(x => x.name)
                    let right = mrole.includes("USER MANAGEMENT");
                    if (right == true) { this.isAdmin = true; } else { this.isAdmin = false; }
                    let trole = role;
                    var name = "USER MANAGEMENT";
                    for (var i = 0; i < trole.length; i++) { if (trole[i].name == name) { trole.splice(i, 1); break; } }
                    this.navbarlist = trole;
                    if(mrole[0] === 'FINANCIAL MANAGEMENT') { this.router.navigate(['/finance']);}
                }
                else {this.router.navigate(['/changepassword']);}
                Helpers.setLoading(false);
            })
            Helpers.setLoading(false);
        }
        else {this.logout();}
    }

    public outsession(data) { if (data == 0) { localStorage.removeItem('currentUser'); this.router.navigate(['/login']) } }

    public logout() {
        const user = JSON.parse(localStorage.getItem('currentUser'));
        if (user) {
            localStorage.removeItem('currentUser');
            this.router.navigate(['/login']);
            this._username = '';
        }
    }

    ngAfterViewInit() {
        //  mLayout.initHeader();
    }

}


// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/main/layouts/header-nav/header-nav.component.ts